var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCallWrapper(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_2426_337170)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40.0001,
    r: 40,
    fill: "url(#paint0_linear_2426_337170)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40.0001,
    r: 40,
    fill: "url(#paint1_radial_2426_337170)",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40.0001,
    r: 40,
    fill: "url(#paint2_radial_2426_337170)",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40.0001,
    r: 40,
    fill: "url(#paint3_radial_2426_337170)",
    fillOpacity: 0.8
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_2426_337170",
    x: -7.43727,
    y: 0.00012207,
    width: 87.4373,
    height: 80,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -7.43727
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.43727
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.80575 0 0 0 0 0.7375 0 0 0 0 1 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2426_337170"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2426_337170",
    x1: 72.5,
    y1: 4.37512,
    x2: 3.30456,
    y2: 86.1152,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C73FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.527788,
    stopColor: "#6E41EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.880184,
    stopColor: "#D641EE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_2426_337170",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.6949 -17.3912) rotate(96.1584) scale(97.9566 163.285)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52B6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8F41EE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_2426_337170",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.3559 4.6378) rotate(62.2005) scale(39.9762 114.742)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9DD6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8F41EE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_2426_337170",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(117.966 61.1595) rotate(144.328) scale(67.5991 92.9769)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5263FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8F41EE",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallWrapper);
export default __webpack_public_path__ + "static/media/CallWrapper.1dfa657073c70bf4a2e74d085662dff6.svg";
export { ForwardRef as ReactComponent };